(() => {
  const query = `query ProjectContents($id: ID!, $country: CountryCode) @inContext(country: $country) {
    node(id: $id) { ... on ProductVariant {
      components(first: 30) { nodes { quantity productVariant {
        id title price { amount currencyCode }
        image { url altText }
        product { title handle featuredImage { url altText } }
      } } }
    } }
  }`;

  function init(root) {
    if (root.dataset.componentsBound) return;
    root.dataset.componentsBound = 'true';
    const select = root.querySelector('select[name="id"]') || root.querySelector('[data-component-variant]');
    const grid = root.querySelector('[data-components-grid]');
    const status = root.querySelector('[data-components-status]');
    if (!select || !grid || !status) return;
    const base = window.Shopify?.routes?.root || '/';
    const cache = new Map();
    let generation = 0;
    let activeRequest;

    function render(components) {
      const fragment = document.createDocumentFragment();
      for (const component of (root.dataset.componentsLimit ? components.slice(0, Number(root.dataset.componentsLimit)) : components)) {
        const variant = component.productVariant;
        const product = variant?.product;
        if (!product) continue;
        const numericId = variant.id.split('/').pop();
        const href = base + 'products/' + encodeURIComponent(product.handle) + '?variant=' + encodeURIComponent(numericId);
        const article = document.createElement('article');
        article.className = 'gf-project-detail__item';
        const imageLink = document.createElement('a');
        imageLink.href = href;
        imageLink.setAttribute('aria-label', product.title);
        const image = variant.image || product.featuredImage;
        if (image?.url) {
          const img = document.createElement('img');
          img.src = image.url;
          img.alt = image.altText || product.title;
          img.loading = 'lazy';
          img.width = 650;
          img.height = 650;
          imageLink.append(img);
          article.append(imageLink);
        }
        const heading = document.createElement('h3');
        const titleLink = document.createElement('a');
        titleLink.href = href;
        titleLink.textContent = product.title;
        heading.append(titleLink);
        article.append(heading);
        if (root.dataset.compactComponents !== 'true' && variant.title && variant.title !== 'Default Title') {
          const option = document.createElement('p');
          option.textContent = variant.title;
          article.append(option);
        }
        if (root.dataset.compactComponents !== 'true') {
          const quantity = document.createElement('p');
          quantity.textContent = (root.dataset.quantityLabel || 'Included quantity:') + ' ' + component.quantity;
          article.append(quantity);
        }
        if (root.dataset.compactComponents !== 'true' && variant.price) {
          const price = document.createElement('p');
          price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
            style: 'currency', currency: variant.price.currencyCode
          }).format(Number(variant.price.amount));
          article.append(price);
        }
        const link = document.createElement('a');
        link.className = 'gf-project-detail__item-link';
        link.href = href;
        link.textContent = root.dataset.itemLinkLabel + ' →';
        article.append(link);
        fragment.append(article);
      }
      grid.replaceChildren(fragment);
      status.textContent = components.length ? '' : root.dataset.errorLabel;
    }

    async function load() {
      const currentGeneration = ++generation;
      activeRequest?.abort();
      const id = select.value;
      grid.replaceChildren();
      status.textContent = root.dataset.loadingLabel;
      if (cache.has(id)) { render(cache.get(id)); return; }
      activeRequest = new AbortController();
      const controller = activeRequest;
      const timeout = window.setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch('/api/2026-07/graphql.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          signal: controller.signal,
          body: JSON.stringify({query, variables: {
            id: 'gid://shopify/ProductVariant/' + id,
            country: /^[A-Z]{2}$/.test(root.dataset.country || '') ? root.dataset.country : null
          }})
        });
        if (!response.ok) throw new Error('Bundle lookup failed');
        const result = await response.json();
        if (result.errors?.length || !result.data?.node?.components) throw new Error('Bundle contents unavailable');
        if (currentGeneration !== generation) return;
        const components = result.data.node.components.nodes;
        cache.set(id, components);
        render(components);
      } catch (error) {
        if (currentGeneration === generation) status.textContent = root.dataset.errorLabel;
      } finally {
        window.clearTimeout(timeout);
      }
    }
    select.addEventListener('change', load);
    load();
  }
  function initAll(scope) {
    scope.querySelectorAll('[data-automatic-project]').forEach(init);
  }
  initAll(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document), {once:true});
  if (!window.gfProjectComponentsEditorBound) {
    window.gfProjectComponentsEditorBound = true;
    document.addEventListener('shopify:section:load', event => initAll(event.target));
  }
})();
